import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import CompanyContext from '../../contexts/company/CompanyContext';
import LoadingCurtain from '../../components/@shared/LoadingCurtain';
import { useCompanyTabs } from './useCompanyTabs';

export { COMPANY_PAGE_PATH } from './useCompanyTabs';
export const COMPANY_PAGE_TITLE = 'Mon entreprise';

// "Mon entreprise" has no content of its own: it opens the first tab the user can see
const CompanyPage: React.FC = () => {
  const { status } = useContext(CompanyContext);
  const tabs = useCompanyTabs();

  // opened directly (link, reload), the company is not loaded yet and there is no tab to land on
  if (status === ContextStatus.IDLE || status === ContextStatus.LOADING) return <LoadingCurtain />;

  return <Navigate to={tabs[0]?.path ?? '/'} replace />;
};

export default CompanyPage;
